import { Recipe } from "./types";

// Main Dishes Recipes - Single source of truth for all main dishes descriptions
export const mainDishRecipes: Record<string, Recipe> = {
  "greek-lentil-soup": {
    id: "greek-lentil-soup",
    name: "Greek Lentil Soup",
    nameFr: "Soupe grecque aux lentilles",
    nameKey: "recipes.greekLentilSoup.name",
    description:
      "Hearty traditional Greek soup with tender lentils, vegetables, and Mediterranean herbs",
    descriptionFr:
      "Soupe grecque traditionnelle aux lentilles tendres, légumes et herbes méditerranéennes",
    descriptionKey: "recipes.greekLentilSoup.description",
    vegetarian: true,
  },

  "pork-chops": {
    id: "pork-chops",
    name: "Pork Chops",
    nameFr: "Côtelettes de porc",
    nameKey: "recipes.porkChops.name",
    description:
      "Succulent pork chops marinated in extra-virgin olive oil, garlic, oregano, and fresh lemon juice, then grilled to juicy perfection. Served with fresh vegetables and your choice of side for an authentic Greek taverna experience",
    descriptionFr:
      "Côtelettes de porc marinées dans de l'huile d'olive extra-vierge, de l'ail, de l'origan et du jus de citron frais, puis grillées à la perfection. Servies avec des légumes frais et au choix d'un accompagnement pour une expérience authentique de taverne grecque",
    descriptionKey: "recipes.porkChops.description",
    vegetarian: false,
  },

  "fish-n-chips": {
    id: "fish-n-chips",
    name: "Fish and Chips",
    nameFr: "Fish and Chips",
    nameKey: "recipes.fishAndChips.name",
    description:
      "Fresh Atlantic cod fillets, hand-dipped in our light, crispy beer batter and fried to golden perfection. Served with thick-cut fries and housemade tartar sauce for a timeless classic",
    descriptionFr:
      "Filets de cabillaud de l'Atlantique frais, trempés à la main dans notre pâte légère et croustillante à la bière, frits à la perfection dorée. Servis avec des frites épaisses et sauce tartare maison pour un classique intemporel",
    descriptionKey: "recipes.fishAndChips.description",
    vegetarian: false,
  },

  "pork-souvlaki-1": {
    id: "pork-souvlaki-1",
    name: "Pork Souvlaki (1 Skewer)",
    nameFr: "Souvlaki au Porc (1 bâton)",
    nameKey: "recipes.porkSouvlaki1.name",
    description:
      "One tender pork skewer served with tzatziki sauce, accompanied by house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Une tendre brochette de porc servie avec sauce tzatziki, accompagnée de notre riz maison, de patates grecques, d’une soupe ou d’une salade au choix",
    descriptionKey: "recipes.porkSouvlaki1.description",
    vegetarian: false,
  },

  "chicken-souvlaki-1": {
    id: "chicken-souvlaki-1",
    name: "Chicken Souvlaki (1 Skewer)",
    nameFr: "Souvlaki au Poulet (1 bâton)",
    nameKey: "recipes.chickenSouvlaki1.name",
    description:
      "One grilled chicken skewer served with tzatziki sauce, paired with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Une brochette de poulet grillé servie avec sauce tzatziki, accompagnée de notre riz maison, de patates grecques, d’une soupe ou d’une salade au choix",
    descriptionKey: "recipes.chickenSouvlaki1.description",
    vegetarian: false,
  },

  "spicy-sausages": {
    id: "spicy-sausages",
    name: "Spicy Sausages",
    nameFr: "Saucisses piquantes",
    nameKey: "recipes.spicySausages.name",
    description:
      "Grilled spicy sausages served with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Saucisses piquantes grillées servies avec notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.spicySausages.description",
    vegetarian: false,
  },

  "white-fish-baked": {
    id: "white-fish-baked",
    name: "Baked White Fish Fillet",
    nameFr: "Filet de poisson blanc au four",
    nameKey: "recipes.bakedWhiteFish.name",
    description:
      "Oven-baked white fish fillet served with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Filet de poisson blanc cuit au four, servi avec notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.bakedWhiteFish.description",
    vegetarian: false,
  },

  "white-fish-breaded": {
    id: "white-fish-breaded",
    name: "Breaded White Fish Fillet",
    nameFr: "Filet de poisson blanc pané",
    nameKey: "recipes.breadedWhiteFish.name",
    description:
      "Crispy breaded white fish fillet served with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Filet de poisson blanc pané et croustillant, servi avec notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.breadedWhiteFish.description",
    vegetarian: false,
  },

  "salmon-baked": {
    id: "salmon-baked",
    name: "Baked Salmon Fillet",
    nameFr: "Filet de saumon au four",
    nameKey: "recipes.bakedSalmon.name",
    description:
      "Fresh salmon fillet baked to perfection, served with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Filet de saumon frais cuit au four à la perfection, servi avec notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.bakedSalmon.description",
    vegetarian: false,
  },

  "salmon-butterfly-shrimp": {
    id: "salmon-butterfly-shrimp",
    name: "Baked Salmon with Butterfly Shrimp",
    nameFr: "Filet de saumon et crevettes papillon",
    nameKey: "recipes.salmonButterflyShrimp.name",
    description:
      "Oven-baked salmon fillet paired with butterfly shrimp, served with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Filet de saumon cuit au four accompagné de crevettes papillon, servi avec notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.salmonButterflyShrimp.description",
    vegetarian: false,
  },

  "butterfly-shrimp": {
    id: "butterfly-shrimp",
    name: "Butterfly Shrimp",
    nameFr: "Crevettes papillon",
    nameKey: "recipes.butterflyShrimp.name",
    description:
      "Golden butterfly shrimp served with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Crevettes papillon dorées servies avec notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.butterflyShrimp.description",
    vegetarian: false,
  },

  "hamburger-steak-mushroom-sauce": {
    id: "hamburger-steak-mushroom-sauce",
    name: "Hamburger Steak with Mushroom Sauce",
    nameFr: "Hamburger Steak (sauce aux champignons)",
    nameKey: "recipes.hamburgerSteakMushroom.name",
    description:
      "Homestyle hamburger steak topped with mushroom sauce, served with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Hamburger steak maison nappé d'une sauce aux champignons, servi avec notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.hamburgerSteakMushroom.description",
    vegetarian: false,
  },

  "chicken-skewer": {
    id: "chicken-skewer",
    name: "Chicken Skewer",
    nameFr: "Brochette de poulet",
    nameKey: "recipes.chickenSkewer.name",
    description:
      "Grilled chicken skewer served with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Brochette de poulet grillé servie avec notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.chickenSkewer.description",
    vegetarian: false,
  },

  "chicken-breast-grilled": {
    id: "chicken-breast-grilled",
    name: "Grilled Chicken Breast",
    nameFr: "Filet de poulet grillé",
    nameKey: "recipes.grilledChickenBreast.name",
    description:
      "Tender grilled chicken breast served with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Filet de poulet tendre grillé, servi avec notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.grilledChickenBreast.description",
    vegetarian: false,
  },

  "chicken-breast-grilled-butterfly-shrimp": {
    id: "chicken-breast-grilled-butterfly-shrimp",
    name: "Grilled Chicken Breast and 2 Butterfly Shrimp",
    nameFr: "Filet de poulet grillé et 2 crevettes papillon",
    nameKey: "recipes.grilledChickenButterflyShrimp.name",
    description:
      "Grilled chicken breast paired with two butterfly shrimp, served with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Filet de poulet grillé accompagné de deux crevettes papillon, servi avec notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.grilledChickenButterflyShrimp.description",
    vegetarian: false,
  },

  "white-fish-butterfly-shrimp": {
    id: "white-fish-butterfly-shrimp",
    name: "White Fish Fillet and Butterfly Shrimp",
    nameFr: "Filet de poisson blanc et crevettes papillon",
    nameKey: "recipes.whiteFishButterflyShrimp.name",
    description:
      "White fish fillet paired with butterfly shrimp, served with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Filet de poisson blanc accompagné de crevettes papillon, servi avec notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.whiteFishButterflyShrimp.description",
    vegetarian: false,
  },

  "ground-beef-steak": {
    id: "ground-beef-steak",
    name: "Ground Beef Steak",
    nameFr: "Bifteck haché",
    nameKey: "recipes.groundBeefSteak.name",
    description:
      "Ground beef steak topped with mushroom sauce, served with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Bifteck haché nappé d'une sauce aux champignons, servi avec notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.groundBeefSteak.description",
    vegetarian: false,
  },

  "frog-legs": {
    id: "frog-legs",
    name: "Frog Legs",
    nameFr: "Cuisses de grenouille",
    nameKey: "recipes.frogLegs.name",
    description:
      "Lightly seasoned frog legs served with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Cuisses de grenouille légèrement assaisonnées, servies avec notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.frogLegs.description",
    vegetarian: false,
  },

  "filet-mignon-medallion": {
    id: "filet-mignon-medallion",
    name: "Filet Mignon Medallion",
    nameFr: "Médaillon de filet mignon",
    nameKey: "recipes.filetMignonMedallion.name",
    description:
      "Premium filet mignon medallion topped with mushroom sauce, served with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Médaillon de filet mignon accompagné d'une sauce aux champignons, servi avec notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.filetMignonMedallion.description",
    vegetarian: false,
  },

  "cava-grecque-steak": {
    id: "cava-grecque-steak",
    name: "Cava Grecque Steak",
    nameFr: "Steak à la Cava Grecque",
    nameKey: "recipes.cavaGrecqueSteak.name",
    description:
      "Steak seasoned with Cava Grecque spices, served with mushroom sauce, house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Steak assaisonné aux épices Cava Grecque, servi avec sauce aux champignons, riz maison, patates grecques, soupe ou salade au choix",
    descriptionKey: "recipes.cavaGrecqueSteak.description",
    vegetarian: false,
  },

  scallops: {
    id: "scallops",
    name: "Coquille St-Jacques",
    nameFr: "Coquille St-Jacques",
    nameKey: "recipes.scallopsMain.name",
    description:
      "Pan-seared scallops served with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Coquilles St-Jacques poêlées servies avec notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.scallopsMain.description",
    vegetarian: false,
  },

  "fried-calamari": {
    id: "fried-calamari",
    name: "Fried Calamari",
    nameFr: "Calmars frits",
    nameKey: "recipes.friedCalamariMain.name",
    description:
      "Crispy fried calamari served with cocktail sauce, house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Calmars frits croustillants servis avec une sauce cocktail, notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.friedCalamariMain.description",
    vegetarian: false,
  },

  "filet-mignon-skewer": {
    id: "filet-mignon-skewer",
    name: "Filet Mignon Skewer",
    nameFr: "Brochette de filet mignon",
    nameKey: "recipes.filetMignonSkewer.name",
    description:
      "Tender filet mignon skewer served with mushroom sauce, house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Brochette de filet mignon tendre servie avec sauce aux champignons, notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.filetMignonSkewer.description",
    vegetarian: false,
  },

  "filet-mignon-butterfly-shrimp": {
    id: "filet-mignon-butterfly-shrimp",
    name: "Filet Mignon and Butterfly Shrimp",
    nameFr: "Filet mignon et crevettes papillon",
    nameKey: "recipes.filetMignonButterflyShrimp.name",
    description:
      "Premium filet mignon served alongside butterfly shrimp, paired with mushroom sauce, house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Filet mignon servi avec des crevettes papillon, accompagné de sauce aux champignons, riz maison, patates grecques, soupe ou salade au choix",
    descriptionKey: "recipes.filetMignonButterflyShrimp.description",
    vegetarian: false,
  },

  "chicken-parmesan": {
    id: "chicken-parmesan",
    name: "Chicken Parmesan",
    nameFr: "Poulet parmesan",
    nameKey: "recipes.chickenParmesan.name",
    description:
      "Breaded chicken breast topped with meat sauce and Parmesan, served with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Poitrine de poulet panée nappée de sauce à la viande et de parmesan, servie avec notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.chickenParmesan.description",
    vegetarian: false,
  },

  "shish-kebab": {
    id: "shish-kebab",
    name: "Shish Kebab",
    nameFr: "Shish Kebab",
    nameKey: "recipes.shishKebab.name",
    description:
      "Grilled pork skewer served with house rice, Greek potatoes, soup or your choice of salad",
    descriptionFr:
      "Brochette de porc grillé servie avec notre riz maison, des patates grecques, une soupe ou une salade au choix",
    descriptionKey: "recipes.shishKebab.description",
    vegetarian: false,
  },

  "chef-salad-grilled-chicken": {
    id: "delson-dinner-salads-chef-salad-with-grilled-chicken",
    name: "Chef Salad with Grilled Chicken",
    nameFr: "Salade du chef avec poulet grillé",
    nameKey: "menuItems.chefSaladGrilledChicken.name",
    description:
      "Chef salad enhanced with tender grilled chicken for a hearty and flavorful meal",
    descriptionFr:
      "Salade du chef garnie de poulet grillé tendre pour un repas savoureux",
    descriptionKey: "menuItems.chefSaladGrilledChicken.description",
  },

  "chef-salad-grilled-salmon": {
    id: "delson-dinner-salads-chef-salad-with-grilled-salmon",
    name: "Chef Salad with Grilled Salmon",
    nameFr: "Salade du chef avec saumon grillé",
    nameKey: "menuItems.chefSaladGrilledSalmon.name",
    description:
      "Chef salad topped with perfectly grilled salmon for a refined, protein-rich option",
    descriptionFr:
      "Salade du chef garnie de saumon grillé, une option raffinée et riche en protéines",
    descriptionKey: "menuItems.chefSaladGrilledSalmon.description",
  },

  "caesar-salad-grilled-chicken": {
    id: "delson-dinner-salads-caesar-with-grilled-chicken",
    name: "Caesar Salad with Grilled Chicken",
    nameFr: "Salade césar avec poulet grillé",
    nameKey: "menuItems.caesarGrilledChicken.name",
    description:
      "Classic Caesar salad topped with juicy grilled chicken for added flavor and protein",
    descriptionFr:
      "Salade césar classique garnie de poulet grillé pour plus de saveur et de protéines",
    descriptionKey: "menuItems.caesarGrilledChicken.description",
  },

  "house-salad": {
    id: "delson-dinner-salads-house-salad",
    name: "House Salad",
    nameFr: "Salade maison",
    nameKey: "menuItems.houseSalad.name",
    description:
      "A refreshing blend of mixed greens served with house dressing",
    descriptionFr:
      "Un mélange rafraîchissant de verdure servi avec la vinaigrette maison",
    descriptionKey: "menuItems.houseSalad.description",
    vegetarian: true,
  },

  "greek-salad-grilled-chicken": {
    id: "delson-dinner-salads-greek-salad-with-grilled-chicken",
    name: "Greek Salad with Grilled Chicken",
    nameFr: "Salade grecque avec poulet grillé",
    nameKey: "menuItems.greekSaladGrilledChicken.name",
    description:
      "Greek salad topped with seasoned grilled chicken for a balanced, satisfying dish",
    descriptionFr:
      "Salade grecque garnie de poulet grillé assaisonné pour un repas équilibré et satisfaisant",
    descriptionKey: "menuItems.greekSaladGrilledChicken.description",
  },

  spaghetti: {
    id: "delson-dinner-pastas-spaghetti",
    name: "Spaghetti",
    nameFr: "Spaghetti",
    nameKey: "menuItems.spaghetti.name",
    description: "Classic spaghetti served with rich and savory meat sauce",
    descriptionFr:
      "Spaghetti servi avec une sauce à la viande riche et savoureuse",
    descriptionKey: "menuItems.spaghetti.description",
  },

  "baked-spaghetti": {
    id: "delson-dinner-pastas-baked-spaghetti",
    name: "Baked Spaghetti",
    nameFr: "Spaghetti gratiné",
    nameKey: "menuItems.bakedSpaghetti.name",
    description:
      "Oven-baked spaghetti layered with hearty meat sauce and melted cheese",
    descriptionFr:
      "Spaghetti gratiné au four avec sauce à la viande et fromage fondu",
    descriptionKey: "menuItems.bakedSpaghetti.description",
  },

  "baked-lasagna": {
    id: "delson-dinner-pastas-baked-lasagna",
    name: "Baked Lasagna",
    nameFr: "Lasagne gratinée",
    nameKey: "menuItems.bakedLasagna.name",
    description:
      "Traditional baked lasagna with layered pasta, rich meat sauce, and melted cheese",
    descriptionFr:
      "Lasagne traditionnelle gratinée avec pâtes en couches, sauce à la viande et fromage fondu",
    descriptionKey: "menuItems.bakedLasagna.description",
  },

  "fisherman-plate": {
    id: "delson-dinner-main-dishes-fisherman-plate",
    name: "Fisherman Plate",
    nameFr: "Assiette du pêcheur",
    nameKey: "menuItems.fishermanPlate.name",
    description:
      "A generous seafood platter featuring white fish fillet, butterfly shrimp, scallops, grilled langoustines, and tender frog legs",
    descriptionFr:
      "Une généreuse assiette de fruits de mer comprenant filet de poisson blanc, crevettes papillon, pétoncles, langoustines grillées et cuisses de grenouille",
    descriptionKey: "menuItems.fishermanPlate.description",
  },

  "grilled-scallops": {
    id: "delson-dinner-main-dishes-grilled-scallops",
    name: "Grilled Scallops",
    nameFr: "Pétoncles grillés",
    nameKey: "menuItems.grilledScallops.name",
    description:
      "Fresh scallops grilled to perfection for a delicate and refined seafood dish",
    descriptionFr:
      "Pétoncles frais grillés à la perfection pour un plat de fruits de mer raffiné",
    descriptionKey: "menuItems.grilledScallops.description",
  },

  "chicken-scallops-skewer": {
    id: "delson-dinner-main-dishes-chicken-scallops-skewer",
    name: "Chicken and Grilled Scallops Skewer",
    nameFr: "Brochette de poulet et pétoncles grillés",
    nameKey: "menuItems.chickenScallopsSkewer.name",
    description:
      "A flavourful skewer combining grilled chicken with perfectly grilled scallops",
    descriptionFr:
      "Une brochette savoureuse combinant poulet grillé et pétoncles grillés",
    descriptionKey: "menuItems.chickenScallopsSkewer.description",
  },

  "chicken-frog-skewer": {
    id: "delson-dinner-main-dishes-chicken-frog-skewer",
    name: "Chicken and Frog Legs Skewer",
    nameFr: "Brochette de poulet et cuisses de grenouille",
    nameKey: "menuItems.chickenFrogSkewer.name",
    description:
      "A unique skewer pairing grilled chicken with tender frog legs",
    descriptionFr:
      "Une brochette unique combinant poulet grillé et cuisses de grenouille tendres",
    descriptionKey: "menuItems.chickenFrogSkewer.description",
  },

  // Kids Menu
  "kids-souvlaki-single": {
    id: "delson-dinner-kids-souvlaki-single",
    name: "Souvlaki (1)",
    nameFr: "Souvlaki (1)",
    nameKey: "menuItems.souvlakiSingle.name",
    description: "A single grilled pork skewer, cooked to perfection",
    descriptionFr: "Un seul souvlaki de porc grillé à la perfection",
    descriptionKey: "menuItems.souvlakiSingle.description",
  },

  "kids-chicken-souvlaki": {
    id: "delson-dinner-kids-chicken-souvlaki",
    name: "Chicken Souvlaki",
    nameFr: "Souvlaki Poulet",
    nameKey: "menuItems.chickenSouvlaki.name",
    description: "A tender grilled chicken skewer, seasoned and flame-grilled",
    descriptionFr:
      "Une brochette de poulet tendre, assaisonnée et grillée à la flamme",
    descriptionKey: "menuItems.chickenSouvlaki.description",
  },

  "kids-chicken-nuggets": {
    id: "delson-dinner-kids-chicken-nuggets-plate",
    name: "Chicken Nuggets Plate",
    nameFr: "Assiette de croquettes de poulet",
    nameKey: "menuItems.chickenNuggetsPlate.name",
    description: "Crispy, golden chicken nuggets made with tender white meat",
    descriptionFr:
      "Croquettes de poulet dorées et croustillantes, préparées avec du blanc de poulet tendre",
    descriptionKey: "menuItems.chickenNuggetsPlate.description",
  },

  "kids-spaghetti": {
    id: "delson-dinner-kids-spaghetti",
    name: "Spaghetti",
    nameFr: "Spaghetti",
    nameKey: "menuItems.spaghettiKids.name",
    description: "Classic spaghetti topped with a rich, savory meat sauce",
    descriptionFr:
      "Spaghetti classique nappé d'une sauce à la viande riche et savoureuse",
    descriptionKey: "menuItems.spaghettiKids.description",
  },

  "kids-gratin-spaghetti": {
    id: "delson-dinner-kids-gratin-spaghetti",
    name: "Gratin Spaghetti",
    nameFr: "Spaghetti gratiné",
    nameKey: "menuItems.gratinSpaghettiKids.name",
    description:
      "Baked spaghetti with meat sauce, finished with a melted cheese topping",
    descriptionFr:
      "Spaghetti gratiné au four avec sauce à la viande et garni de fromage fondant",
    descriptionKey: "menuItems.gratinSpaghettiKids.description",
  },

  "kids-gratin-lasagna": {
    id: "delson-dinner-kids-gratin-lasagna",
    name: "Gratin Lasagna",
    nameFr: "Lasagne gratinée",
    nameKey: "menuItems.gratinLasagnaKids.name",
    description: "Oven-baked lasagna layered with meat sauce and melted cheese",
    descriptionFr:
      "Lasagne cuite au four, garnie de sauce à la viande et de fromage fondant",
    descriptionKey: "menuItems.gratinLasagnaKids.description",
  },

  // TODO: Remove addons from descriptions and improve descriptions
  "chicken-shrimp-skewer": {
    id: "chicken-shrimp-skewer",
    name: "Chicken Skewer & Butterfly Shrimp",
    nameFr: "Brochette de poulet et crevettes papillon",
    nameKey: "recipes.chickenShrimpSkewer.name",
    description:
      "Chicken skewer with butterfly shrimp, includes rice, Greek potatoes, soup or salad, coffee, and dessert",
    descriptionFr: "Brochette de poulet et crevettes papillon",
    descriptionKey: "recipes.chickenShrimpSkewer.description",
    vegetarian: false,
  },

  "chicken-calamari-skewer": {
    id: "chicken-calamari-skewer",
    name: "Chicken Skewer & Fried Calamari",
    nameFr: "Brochette de poulet et calmars frits",
    nameKey: "recipes.chickenCalamariSkewer.name",
    description:
      "Chicken skewer with fried calamari, served with cocktail sauce, includes rice, Greek potatoes, soup or salad, coffee, and dessert",
    descriptionFr: "Servie avec une sauce cocktail",
    descriptionKey: "recipes.chickenCalamariSkewer.description",
    vegetarian: false,
  },

  "grilled-chicken": {
    id: "grilled-chicken",
    name: "Grilled Chicken",
    nameFr: "Filet de poulet grillé",
    nameKey: "recipes.grilledChickenForTwo.name",
    description:
      "Grilled chicken filet, includes rice, Greek potatoes, soup or salad, coffee, and dessert",
    descriptionFr: "Filet de poulet grillé",
    descriptionKey: "recipes.grilledChickenForTwo.description",
    vegetarian: false,
  },

  "grilled-chicken-shrimp": {
    id: "grilled-chicken-shrimp",
    name: "Grilled Chicken & Butterfly Shrimp",
    nameFr: "Filet de poulet et crevettes papillon",
    nameKey: "recipes.grilledChickenShrimp.name",
    description:
      "Grilled chicken filet with butterfly shrimp, includes rice, Greek potatoes, soup or salad, coffee, and dessert",
    descriptionFr: "Filet de poulet et crevettes papillon",
    descriptionKey: "recipes.grilledChickenShrimp.description",
    vegetarian: false,
  },

  "baked-white-fish": {
    id: "baked-white-fish",
    name: "Baked White Fish",
    nameFr: "Filet de poisson blanc au four",
    nameKey: "recipes.bakedWhiteFish.name",
    description:
      "Baked white fish filet, includes rice, Greek potatoes, soup or salad, coffee, and dessert",
    descriptionFr: "Filet de poisson blanc au four",
    descriptionKey: "recipes.bakedWhiteFish.description",
    vegetarian: false,
  },

  "breaded-white-fish": {
    id: "breaded-white-fish",
    name: "Breaded White Fish",
    nameFr: "Filet de poisson blanc pané",
    nameKey: "recipes.breadedWhiteFish.name",
    description:
      "Breaded white fish filet, includes rice, Greek potatoes, soup or salad, coffee, and dessert",
    descriptionFr: "Filet de poisson blanc pané",
    descriptionKey: "recipes.breadedWhiteFish.description",
    vegetarian: false,
  },

  "white-fish-shrimp": {
    id: "white-fish-shrimp",
    name: "White Fish & Butterfly Shrimp",
    nameFr: "Filet de poisson blanc avec crevettes papillon",
    nameKey: "recipes.whiteFishShrimp.name",
    description:
      "White fish filet with butterfly shrimp, includes rice, Greek potatoes, soup or salad, coffee, and dessert",
    descriptionFr: "Filet de poisson blanc avec crevettes papillon",
    descriptionKey: "recipes.whiteFishShrimp.description",
    vegetarian: false,
  },

  "baked-salmon": {
    id: "baked-salmon",
    name: "Baked Salmon",
    nameFr: "Filet de saumon au four",
    nameKey: "recipes.bakedSalmon.name",
    description:
      "Baked salmon filet, includes rice, Greek potatoes, soup or salad, coffee, and dessert",
    descriptionFr: "Filet de saumon au four",
    descriptionKey: "recipes.bakedSalmon.description",
    vegetarian: false,
  },

  "salmon-shrimp": {
    id: "salmon-shrimp",
    name: "Salmon & Butterfly Shrimp",
    nameFr: "Filet de saumon et crevettes papillon",
    nameKey: "recipes.salmonShrimp.name",
    description:
      "Salmon filet with butterfly shrimp, includes rice, Greek potatoes, soup or salad, coffee, and dessert",
    descriptionFr: "Filet de saumon et crevettes papillon",
    descriptionKey: "recipes.salmonShrimp.description",
    vegetarian: false,
  },

  "filet-mignon-shrimp": {
    id: "filet-mignon-shrimp",
    name: "Filet Mignon & Butterfly Shrimp",
    nameFr: "Filet mignon et crevettes papillon",
    nameKey: "recipes.filetMignonShrimp.name",
    description:
      "Filet mignon with butterfly shrimp, served with mushroom sauce, includes rice, Greek potatoes, soup or salad, coffee, and dessert",
    descriptionFr: "Servi avec une sauce aux champignons",
    descriptionKey: "recipes.filetMignonShrimp.description",
    vegetarian: false,
  },

  "minced-steak": {
    id: "minced-steak",
    name: "Minced Steak",
    nameFr: "Bifteck haché",
    nameKey: "recipes.mincedSteak.name",
    description:
      "Minced steak served with mushroom sauce, includes rice, Greek potatoes, soup or salad, coffee, and dessert",
    descriptionFr: "Servi avec une sauce aux champignons",
    descriptionKey: "recipes.mincedSteak.description",
    vegetarian: false,
  },

  "greek-cava-steak": {
    id: "greek-cava-steak",
    name: "Greek Cava Steak",
    nameFr: "Steak à la Cava Grecque",
    nameKey: "recipes.greekCavaSteak.name",
    description:
      "Greek-style steak served with mushroom sauce, includes rice, Greek potatoes, soup or salad, coffee, and dessert",
    descriptionFr: "Servi avec une sauce aux champignons",
    descriptionKey: "recipes.greekCavaSteak.description",
    vegetarian: false,
  },

  "grilled-langoustines": {
    id: "grilled-langoustines",
    name: "Grilled Langoustines",
    nameFr: "Langoustines grillées",
    nameKey: "recipes.grilledLangoustines.name",
    description:
      "Choice of appetizers: gratinated escargots, tzatziki, taramosalata, marinated palm hearts, marinated artichokes. Served with soup or salad, rice, Greek potatoes, coffee, and dessert",
    descriptionFr:
      "Choix d'entrées: Escargots gratinés / Tzatziki / Taramosalata / Cours de Palmier marinés / Coeurs d'articauts marinés. Tous ces plats sont servis avec un choix de soupe ou salade, riz maison, patates grecques, café et dessert",
    descriptionKey: "recipes.grilledLangoustines.description",
    vegetarian: false,
  },

  "white-fish-langoustines": {
    id: "white-fish-langoustines",
    name: "White Fish & Langoustines",
    nameFr: "Filet de poisson blanc et langoustines",
    nameKey: "recipes.fishLangoustines.name",
    description:
      "Baked white fish filet with langoustines. Choice of appetizers, soup or salad, rice, Greek potatoes, coffee, and dessert",
    descriptionFr: "Filet de poisson blanc et langoustines",
    descriptionKey: "recipes.fishLangoustines.description",
    vegetarian: false,
  },

  "salmon-langoustines": {
    id: "salmon-langoustines",
    name: "Salmon & Langoustines",
    nameFr: "Filet de saumon et langoustines",
    nameKey: "recipes.salmonLangoustines.name",
    description:
      "Baked salmon filet with langoustines. Choice of appetizers, soup or salad, rice, Greek potatoes, coffee, and dessert",
    descriptionFr: "Filet de saumon et langoustines",
    descriptionKey: "recipes.salmonLangoustines.description",
    vegetarian: false,
  },

  "lobster-plate-2": {
    id: "lobster-plate-2",
    name: "Lobster Plate (2)",
    nameFr: "Assiette de homards (2)",
    nameKey: "recipes.lobsterPlate2.name",
    description:
      "All served with house rice, Greek potatoes, garlic butter, soup or salad, coffee, and dessert",
    descriptionFr:
      "Tous ces plats sont servis avec riz maison, patates grecques et beurre d'ail. Soupe ou salade, café et dessert sont inclus",
    descriptionKey: "recipes.lobsterPlate2.description",
    vegetarian: false,
  },

  "lobster-plate-1": {
    id: "lobster-plate-1",
    name: "Lobster Plate (1)",
    nameFr: "Assiette de homard (1)",
    nameKey: "recipes.lobsterPlate1.name",
    description:
      "All served with house rice, Greek potatoes, garlic butter, soup or salad, coffee, and dessert",
    descriptionFr:
      "Tous ces plats sont servis avec riz maison, patates grecques et beurre d'ail. Soupe ou salade, café et dessert sont inclus",
    descriptionKey: "recipes.lobsterPlate1.description",
    vegetarian: false,
  },

  "lobster-filet-mignon": {
    id: "lobster-filet-mignon",
    name: "Lobster & Filet Mignon",
    nameFr: "Homard et filet mignon",
    nameKey: "recipes.lobsterFiletMignon.name",
    description:
      "All served with house rice, Greek potatoes, garlic butter, soup or salad, coffee, and dessert",
    descriptionFr:
      "Tous ces plats sont servis avec riz maison, patates grecques et beurre d'ail. Soupe ou salade, café et dessert sont inclus",
    descriptionKey: "recipes.lobsterFiletMignon.description",
    vegetarian: false,
  },

  "lobster-chicken-fillet": {
    id: "lobster-chicken-fillet",
    name: "Lobster & Chicken Filet",
    nameFr: "Homard et filet de poulet",
    nameKey: "recipes.lobsterChicken.name",
    description:
      "All served with house rice, Greek potatoes, garlic butter, soup or salad, coffee, and dessert",
    descriptionFr:
      "Tous ces plats sont servis avec riz maison, patates grecques et beurre d'ail. Soupe ou salade, café et dessert sont inclus",
    descriptionKey: "recipes.lobsterChicken.description",
    vegetarian: false,
  },

  "lobster-white-fish": {
    id: "lobster-white-fish",
    name: "Lobster & White Fish",
    nameFr: "Homard et filet de poisson",
    nameKey: "recipes.lobsterFish.name",
    description:
      "All served with house rice, Greek potatoes, garlic butter, soup or salad, coffee, and dessert",
    descriptionFr:
      "Tous ces plats sont servis avec riz maison, patates grecques et beurre d'ail. Soupe ou salade, café et dessert sont inclus",
    descriptionKey: "recipes.lobsterFish.description",
    vegetarian: false,
  },

  "lobster-butterfly-shrimp": {
    id: "lobster-butterfly-shrimp",
    name: "Lobster & Butterfly Shrimp",
    nameFr: "Homard et crevettes papillon",
    nameKey: "recipes.lobsterShrimp.name",
    description:
      "All served with house rice, Greek potatoes, garlic butter, soup or salad, coffee, and dessert",
    descriptionFr:
      "Tous ces plats sont servis avec riz maison, patates grecques et beurre d'ail. Soupe ou salade, café et dessert sont inclus",
    descriptionKey: "recipes.lobsterShrimp.description",
    vegetarian: false,
  },

  "langoustine-plate": {
    id: "langoustine-plate",
    name: "Grilled Langoustine Platter",
    nameFr: "Assiette de Langoustines Grillées",
    nameKey: "recipes.langoustinePlate.name",
    description:
      "Delicately grilled langoustines, paired with marinated artichoke hearts, palm hearts, taramosalata, and tzatziki for a refined appetizer experience",
    descriptionFr:
      "Langoustines grillées délicatement, accompagnées de coeurs d'artichauts et de palmiers marinés, taramosalata et tzatziki pour une expérience culinaire raffinée",
    descriptionKey: "recipes.langoustinePlate.description",
    vegetarian: false,
  },

  "surf-turf": {
    id: "surf-turf",
    name: "Surf & Turf Delight",
    nameFr: "Terre et Mer Élégant",
    nameKey: "recipes.surfTurf.name",
    description:
      "A premium combination of succulent grilled steak and fresh langoustines, complemented by marinated artichoke hearts, palm hearts, taramosalata, and tzatziki",
    descriptionFr:
      "Un mariage raffiné de steak grillé tendre et de langoustines fraîches, accompagné de coeurs d'artichauts et de palmiers marinés, taramosalata et tzatziki",
    descriptionKey: "recipes.surfTurf.description",
    vegetarian: false,
  },

  "chicken-langoustines": {
    id: "chicken-langoustines",
    name: "Grilled Chicken & Langoustines",
    nameFr: "Filet de Poulet et Langoustines Grillées",
    nameKey: "recipes.chickenLangoustines.name",
    description:
      "Tender grilled chicken breast paired with juicy langoustines, accompanied by marinated artichoke hearts, palm hearts, taramosalata, and tzatziki",
    descriptionFr:
      "Filet de poulet grillé tendre accompagné de langoustines juteuses, avec coeurs d'artichauts et de palmiers marinés, taramosalata et tzatziki",
    descriptionKey: "recipes.chickenLangoustines.description",
    vegetarian: false,
  },

  "salmon-or-white-fish-langoustines": {
    id: "salmon-or-white-fish-langoustines",
    name: "Salmon or White Fish & Langoustines",
    nameFr: "Filet de Saumon ou Poisson Blanc et Langoustines",
    nameKey: "recipes.salmonOrWhiteFishLangoustines.name",
    description:
      "Oven-baked salmon or white fish fillet served alongside succulent langoustines, enhanced by marinated artichoke hearts, palm hearts, taramosalata, and tzatziki",
    descriptionFr:
      "Filet de saumon ou poisson blanc au four, accompagné de langoustines succulentes, avec coeurs d'artichauts et de palmiers marinés, taramosalata et tzatziki",
    descriptionKey: "recipes.salmonOrWhiteFishLangoustines.description",
    vegetarian: false,
  },

  "chicken-shrimp-skewers": {
    id: "chicken-shrimp-skewers",
    name: "Grilled Chicken & Shrimp Skewers",
    nameFr: "Brochettes de Poulet et Crevettes Grillées",
    nameKey: "recipes.chickenShrimpSkewers.name",
    description:
      "Juicy skewers of grilled chicken and shrimp, complemented by marinated artichoke hearts, palm hearts, taramosalata, and tzatziki",
    descriptionFr:
      "Brochettes juteuses de poulet et crevettes grillées, accompagnées de coeurs d'artichauts et de palmiers marinés, taramosalata et tzatziki",
    descriptionKey: "recipes.chickenShrimpSkewers.description",
    vegetarian: false,
  },

  "pork-souvlaki-pita-1": {
    id: "pork-souvlaki-pita-1",
    name: "Pork Souvlaki Pita (1)",
    nameFr: "Souvlaki au Porc Pita (1)",
    nameKey: "recipes.porkSouvlakiPita1.name",
    description:
      "A warm, freshly grilled pork souvlaki wrapped in a soft pita, served simply and traditionally. Pita only",
    descriptionFr:
      "Un pita garni de souvlaki de porc fraîchement grillé, servi chaud et simplement, dans la tradition grecque. Pita seulement",
    descriptionKey: "recipes.porkSouvlakiPita1.description",
    vegetarian: false,
  },

  "pork-souvlaki-pita-2": {
    id: "pork-souvlaki-pita-2",
    name: "Pork Souvlaki Pita (2)",
    nameFr: "Souvlaki au Porc Pita (2)",
    nameKey: "recipes.porkSouvlakiPita2.name",
    description:
      "Two warm pitas filled with tender grilled pork souvlaki for a heartier, classic Greek bite. Pita only",
    descriptionFr:
      "Deux pitas garnis de tendre souvlaki de porc grillé pour un repas plus consistant aux saveurs grecques authentiques. Pita seulement",
    descriptionKey: "recipes.porkSouvlakiPita2.description",
    vegetarian: false,
  },

  "chicken-souvlaki-pita-1": {
    id: "chicken-souvlaki-pita-1",
    name: "Chicken Souvlaki Pita (1)",
    nameFr: "Souvlaki au Poulet Pita (1)",
    nameKey: "recipes.chickenSouvlakiPita1.name",
    description:
      "A soft pita filled with juicy marinated chicken souvlaki, grilled to perfection. Pita only",
    descriptionFr:
      "Un pita garni de morceaux de poulet souvlaki juteux et marinés, grillés à la perfection. Pita seulement",
    descriptionKey: "recipes.chickenSouvlakiPita1.description",
    vegetarian: false,
  },

  "chicken-souvlaki-pita-2": {
    id: "chicken-souvlaki-pita-2",
    name: "Chicken Souvlaki Pita (2)",
    nameFr: "Souvlaki au Poulet Pita (2)",
    nameKey: "recipes.chickenSouvlakiPita2.name",
    description:
      "Two warm pitas filled with tender marinated chicken souvlaki, grilled and wrapped fresh. Pita only",
    descriptionFr:
      "Deux pitas garnis de tendre souvlaki de poulet mariné, grillé et servi chaud. Pita seulement",
    descriptionKey: "recipes.chickenSouvlakiPita2.description",
    vegetarian: false,
  },

  "gyro-pita-1": {
    id: "gyro-pita-1",
    name: "Gyro Pita (1)",
    nameFr: "Gyro Pita (1)",
    nameKey: "recipes.gyroPita1.name",
    description:
      "A classic Greek pita filled with seasoned gyro meat, sliced thin and served warm. Pita only",
    descriptionFr:
      "Un pita classique garni de viande gyro assaisonnée, tranchée finement et servie chaude. Pita seulement",
    descriptionKey: "recipes.gyroPita1.description",
    vegetarian: false,
  },

  "gyro-pita-2": {
    id: "gyro-pita-2",
    name: "Gyro Pita (2)",
    nameFr: "Gyro Pita (2)",
    nameKey: "recipes.gyroPita2.name",
    description:
      "Two traditional Greek pitas filled with tender, seasoned gyro meat. Pita only",
    descriptionFr:
      "Deux pitas traditionnels garnis de tendre viande gyro assaisonnée. Pita seulement",
    descriptionKey: "recipes.gyroPita2.description",
    vegetarian: false,
  },

  "pork-souvlaki-plate-1": {
    id: "pork-souvlaki-plate-1",
    name: "Pork Souvlaki Plate (1 pita)",
    nameFr: "Assiette Souvlaki au Porc (1 pita)",
    nameKey: "recipes.porkSouvlakiPlate1.name",
    description:
      "Grilled pork souvlaki served with a warm pita, fluffy rice, golden potatoes, and a fresh house salad",
    descriptionFr:
      "Souvlaki de porc grillé servi avec un pita chaud, du riz moelleux, des patates dorées et une salade maison fraîche",
    descriptionKey: "recipes.porkSouvlakiPlate1.description",
    vegetarian: false,
  },

  "pork-souvlaki-plate-2": {
    id: "pork-souvlaki-plate-2",
    name: "Pork Souvlaki Plate (2 pitas)",
    nameFr: "Assiette Souvlaki au Porc (2 pitas)",
    nameKey: "recipes.porkSouvlakiPlate2.name",
    description:
      "A generous serving of grilled pork souvlaki with two pitas, paired with rice, potatoes, and a house salad",
    descriptionFr:
      "Une assiette généreuse de souvlaki de porc grillé accompagnée de deux pitas, avec riz, patates et salade maison",
    descriptionKey: "recipes.porkSouvlakiPlate2.description",
    vegetarian: false,
  },

  "chicken-souvlaki-plate-1": {
    id: "chicken-souvlaki-plate-1",
    name: "Chicken Souvlaki Plate (1 pita)",
    nameFr: "Assiette Souvlaki au Poulet (1 pita)",
    nameKey: "recipes.chickenSouvlakiPlate1.name",
    description:
      "Juicy grilled chicken souvlaki served with a warm pita, rice, roasted potatoes, and a crisp house salad",
    descriptionFr:
      "Poulet souvlaki juteux et grillé, servi avec un pita chaud, du riz, des patates rôties et une salade maison croquante",
    descriptionKey: "recipes.chickenSouvlakiPlate1.description",
    vegetarian: false,
  },

  "chicken-souvlaki-plate-2": {
    id: "chicken-souvlaki-plate-2",
    name: "Chicken Souvlaki Plate (2 pitas)",
    nameFr: "Assiette Souvlaki au Poulet (2 pitas)",
    nameKey: "recipes.chickenSouvlakiPlate2.name",
    description:
      "A double-pita serving of grilled chicken souvlaki, with rice, potatoes, and a fresh house salad",
    descriptionFr:
      "Une portion double de poulet souvlaki grillé avec deux pitas, servie avec riz, patates et salade maison",
    descriptionKey: "recipes.chickenSouvlakiPlate2.description",
    vegetarian: false,
  },

  "gyro-plate-1": {
    id: "gyro-plate-1",
    name: "Gyro Plate (1 pita)",
    nameFr: "Assiette de Gyro Pita (1 pita)",
    nameKey: "recipes.gyroPlate1.name",
    description:
      "Seasoned gyro meat served warm with a pita, fluffy rice, roasted potatoes, and a refreshing house salad",
    descriptionFr:
      "Viande gyro assaisonnée, servie chaude avec un pita, du riz moelleux, des patates rôties et une salade maison rafraîchissante",
    descriptionKey: "recipes.gyroPlate1.description",
    vegetarian: false,
  },

  "gyro-plate-2": {
    id: "gyro-plate-2",
    name: "Gyro Plate (2 pitas)",
    nameFr: "Assiette de Gyro Pita (2 pitas)",
    nameKey: "recipes.gyroPlate2.name",
    description:
      "A hearty gyro plate with double pita, served with rice, golden potatoes, and a fresh house salad",
    descriptionFr:
      "Une assiette généreuse de gyro avec deux pitas, servie avec riz, patates dorées et salade maison fraîche",
    descriptionKey: "recipes.gyroPlate2.description",
    vegetarian: false,
  },

  "kids-pork-souvlaki": {
    id: "kids-pork-souvlaki",
    name: "Kids Pork Souvlaki",
    nameFr: "Souvlaki au porc",
    nameKey: "recipes.kidsPorkSouvlaki.name",
    description:
      "Tender pork skewers served with house-prepared rice and Greek-style roasted potatoes",
    descriptionFr:
      "Brochettes de porc tendres servies avec riz maison et pommes de terre rôties à la grecque",
    descriptionKey: "recipes.kidsPorkSouvlaki.description",
    vegetarian: false,
  },

  "kids-baked-spaghetti": {
    id: "kids-baked-spaghetti",
    name: "Kids Baked Spaghetti with Meat Sauce",
    nameFr: "Spaghetti gratiné avec sauce à la viande",
    nameKey: "recipes.kidsBakedSpaghetti.name",
    description:
      "Oven-baked spaghetti with layers of rich house-made meat sauce and melted cheese",
    descriptionFr:
      "Spaghetti gratiné au four avec sauce à la viande maison riche et fromage fondu",
    descriptionKey: "recipes.kidsBakedSpaghetti.description",
    vegetarian: false,
  },

  "kids-lasagna": {
    id: "kids-lasagna",
    name: "Kids Baked Lasagna with Meat Sauce",
    nameFr: "Lasagne gratinée avec sauce à la viande",
    nameKey: "recipes.kidsLasagna.name",
    description:
      "Layers of pasta, rich house-made meat sauce, and melted cheese baked to perfection",
    descriptionFr:
      "Couches de pâtes, sauce à la viande maison riche et fromage fondu, cuites au four à la perfection",
    descriptionKey: "recipes.kidsLasagna.description",
    vegetarian: false,
  },

  "grilled-chicken-breast-butterfly-shrimp": {
    id: "grilled-chicken-breast-butterfly-shrimp",
    name: "Grilled Chicken Breast and Butterfly Shrimp",
    nameFr: "Filet de poulet grillé et crevettes papillon",
    nameKey: "recipes.grilledChickenBreastButterflyShrimp.name",
    description:
      "Juicy grilled chicken breast served with golden butterfly shrimp. Accompanied by house rice, Greek-style roasted potatoes, and your choice of soup or chef's salad, for a perfectly balanced surf and turf dish",
    descriptionFr:
      "Filet de poulet grillé juteux accompagné de crevettes papillon dorées. Servi avec riz maison, patates grecques rôties et choix de soupe ou salade du chef, pour un plat surf and turf parfaitement équilibré",
    descriptionKey: "recipes.grilledChickenBreastButterflyShrimp.description",
    vegetarian: false,
  },

  "chicken-brochette-butterfly-shrimp": {
    id: "chicken-brochette-butterfly-shrimp",
    name: "Chicken Brochette and Butterfly Shrimp",
    nameFr: "Brochette de poulet et crevettes papillon",
    nameKey: "recipes.chickenBrochetteButterflyShrimp.name",
    description:
      "Skewered chicken brochette grilled to perfection, paired with golden butterfly shrimp. Served with house rice, Greek-style roasted potatoes, and choice of soup or chef's salad for a classic surf and turf combination",
    descriptionFr:
      "Brochette de poulet grillée à la perfection accompagnée de crevettes papillon dorées. Servi avec riz maison, patates grecques rôties et choix de soupe ou salade du chef pour un classique surf and turf",
    descriptionKey: "recipes.chickenBrochetteButterflyShrimp.description",
    vegetarian: false,
  },

  "chicken-brochette-fried-calamari": {
    id: "chicken-brochette-fried-calamari",
    name: "Chicken Brochette and Fried Calamari",
    nameFr: "Brochette de poulet et calmars frits",
    nameKey: "recipes.chickenBrochetteFriedCalamari.name",
    description:
      "Grilled chicken brochette served alongside lightly breaded fried calamari. Comes with house rice, Greek-style roasted potatoes, and choice of soup or chef's salad for a refined surf and turf experience",
    descriptionFr:
      "Brochette de poulet grillée servie avec des calmars frits légèrement panés. Accompagné de riz maison, patates grecques rôties et choix de soupe ou salade du chef pour une expérience surf and turf raffinée",
    descriptionKey: "recipes.chickenBrochetteFriedCalamari.description",
    vegetarian: false,
  },

  "chicken-brochette-scallops": {
    id: "chicken-brochette-scallops",
    name: "Chicken Brochette and Scallops",
    nameFr: "Brochette de poulet et pétoncles",
    nameKey: "recipes.chickenBrochetteScallops.name",
    description:
      "Succulent chicken brochette paired with seared scallops, served with house rice, Greek-style roasted potatoes, and choice of soup or chef's salad. A luxurious surf and turf plate perfect for seafood lovers",
    descriptionFr:
      "Brochette de poulet succulente accompagnée de pétoncles poêlés, servie avec riz maison, patates grecques rôties et choix de soupe ou salade du chef. Un plat surf and turf luxueux idéal pour les amateurs de fruits de mer",
    descriptionKey: "recipes.chickenBrochetteScallops.description",
    vegetarian: false,
  },

  "butterfly-shrimp-plate": {
    id: "butterfly-shrimp-plate",
    name: "Butterfly Shrimp Plate",
    nameFr: "Assiette de crevettes papillon",
    nameKey: "recipes.butterflyShrimpPlate.name",
    description:
      "Plump butterfly shrimp, lightly breaded and fried to a golden crisp. Served with house rice and Greek potatoes for a classic seafood favorite",
    descriptionFr:
      "Crevettes papillon dodues, légèrement panées et frites à la perfection dorée. Servies avec riz maison et patates grecques pour un classique de la mer",
    descriptionKey: "recipes.butterflyShrimpPlate.description",
    vegetarian: false,
  },

  "langoustines-plate": {
    id: "langoustines-plate",
    name: "Langoustines Plate",
    nameFr: "Assiette de langoustines",
    nameKey: "recipes.langoustinesPlate.name",
    description:
      "Delicate langoustines, perfectly grilled or sautéed to bring out their natural sweetness. Served with house rice and Greek potatoes",
    descriptionFr:
      "Langoustines délicates, grillées ou sautées pour révéler leur douceur naturelle. Servies avec riz maison et patates grecques",
    descriptionKey: "recipes.langoustinesPlate.description",
    vegetarian: false,
  },

  "grilled-scallops-plate": {
    id: "grilled-scallops-plate",
    name: "Grilled Scallops Plate",
    nameFr: "Assiette de pétoncles grillés",
    nameKey: "recipes.grilledScallopsPlate.name",
    description:
      "Tender sea scallops, grilled to perfection and served with house rice and Greek potatoes for a succulent seafood experience",
    descriptionFr:
      "Pétoncles de mer tendres, grillés à la perfection. Servis avec riz maison et patates grecques pour une expérience de fruits de mer succulente",
    descriptionKey: "recipes.grilledScallopsPlate.description",
    vegetarian: false,
  },

  "baked-salmon-fillet": {
    id: "baked-salmon-fillet",
    name: "Baked Salmon Fillet",
    nameFr: "Filet de saumon au four",
    nameKey: "recipes.bakedSalmon.name",
    description:
      "Fresh salmon fillet, baked to tender perfection, served with house rice and Greek potatoes for a heart-healthy classic",
    descriptionFr:
      "Filet de saumon frais, cuit au four à la perfection. Servi avec riz maison et patates grecques pour un classique sain et délicieux",
    descriptionKey: "recipes.bakedSalmon.description",
    vegetarian: false,
  },

  "salmon-and-butterfly-shrimp-plate": {
    id: "salmon-and-butterfly-shrimp-plate",
    name: "Salmon and Butterfly Shrimp Plate",
    nameFr: "Assiette de saumon et crevettes papillon",
    nameKey: "recipes.salmonShrimpPlate.name",
    description:
      "A delightful duo of tender baked salmon and crispy butterfly shrimp, served with house rice and Greek potatoes for a luxurious seafood plate",
    descriptionFr:
      "Un duo délicieux de saumon au four tendre et de crevettes papillon croustillantes. Servi avec riz maison et patates grecques pour une assiette de fruits de mer raffinée",
    descriptionKey: "recipes.salmonShrimpPlate.description",
    vegetarian: false,
  },

  "baked-white-fish-fillet": {
    id: "baked-white-fish-fillet",
    name: "Baked White Fish Fillet",
    nameFr: "Filet de poisson blanc au four",
    nameKey: "recipes.bakedWhiteFish.name",
    description:
      "Tender white fish fillet, baked to perfection and served with house rice and Greek potatoes for a delicate seafood option",
    descriptionFr:
      "Filet de poisson blanc tendre, cuit au four à la perfection. Servi avec riz maison et patates grecques pour une option de fruits de mer délicate",
    descriptionKey: "recipes.bakedWhiteFish.description",
    vegetarian: false,
  },

  "breaded-white-fish-fillet": {
    id: "breaded-white-fish-fillet",
    name: "Breaded White Fish Fillet",
    nameFr: "Filet de poisson blanc pané",
    nameKey: "recipes.breadedWhiteFish.name",
    description:
      "White fish fillet, lightly breaded and fried to golden crisp, served with house rice and Greek potatoes",
    descriptionFr:
      "Filet de poisson blanc, légèrement pané et frit à la perfection dorée. Servi avec riz maison et patates grecques",
    descriptionKey: "recipes.breadedWhiteFish.description",
    vegetarian: false,
  },

  "scallops-plate": {
    id: "scallops-plate",
    name: "Coquille St-Jacques Platter",
    nameFr: "Plat de Coquille Saint-Jacques",
    nameKey: "recipes.scallopsPlate.name",
    description:
      "Seared scallops, cooked to perfection and served with house rice and Greek potatoes for a satisfying seafood dish",
    descriptionFr:
      "Pétoncles poêlés, cuits à la perfection. Servis avec riz maison et patates grecques pour un plat de fruits de mer savoureux",
    descriptionKey: "recipes.scallopsPlate.description",
    vegetarian: false,
  },

  "fried-calamari-plate": {
    id: "fried-calamari-plate",
    name: "Fried Calamari Plate",
    nameFr: "Assiette de calmars frits",
    nameKey: "recipes.friedCalamariPlate.name",
    description:
      "Tender calamari rings, lightly breaded and fried golden. Served with house rice and Greek potatoes for a perfect appetizer or main",
    descriptionFr:
      "Anneaux de calmars tendres, légèrement panés et frits à la perfection dorée. Servis avec riz maison et patates grecques pour un excellent plat principal ou entrée",
    descriptionKey: "recipes.friedCalamariPlate.description",
    vegetarian: false,
  },

  "calamari-and-butterfly-shrimp-plate": {
    id: "calamari-and-butterfly-shrimp-plate",
    name: "Fried Calamari and Butterfly Shrimp Plate",
    nameFr: "Assiette de calmars frits et crevettes papillon",
    nameKey: "recipes.calamariShrimpPlate.name",
    description:
      "A delicious combination of fried calamari and crispy butterfly shrimp, served with house rice and Greek potatoes for a hearty seafood plate",
    descriptionFr:
      "Une délicieuse combinaison de calmars frits et crevettes papillon croustillantes. Servie avec riz maison et patates grecques pour une assiette de fruits de mer copieuse",
    descriptionKey: "recipes.calamariShrimpPlate.description",
    vegetarian: false,
  },

  "filet-mignon-medallions": {
    id: "filet-mignon-medallions",
    name: "Filet Mignon Medallions",
    nameFr: "Médaillons de filet mignon",
    nameKey: "recipes.filetMignonMedallions.name",
    description:
      "Tender medallions of filet mignon, seared to perfection and topped with a rich mushroom sauce. Served with house rice and Greek potatoes",
    descriptionFr:
      "Médaillons tendres de filet mignon, saisis à la perfection et nappés d'une riche sauce aux champignons. Servis avec riz maison et patates grecques",
    descriptionKey: "recipes.filetMignonMedallions.description",
    vegetarian: false,
  },

  "filet-mignon-brochette": {
    id: "filet-mignon-brochette",
    name: "Filet Mignon Brochette",
    nameFr: "Brochette de filet mignon",
    nameKey: "recipes.filetMignonBrochette.name",
    description:
      "Juicy cubes of filet mignon skewered and grilled, finished with a savory mushroom sauce. Accompanied by house rice and Greek potatoes",
    descriptionFr:
      "Morceaux juteux de filet mignon en brochette, grillés et nappés d'une savoureuse sauce aux champignons. Accompagnés de riz maison et patates grecques",
    descriptionKey: "recipes.filetMignonBrochette.description",
    vegetarian: false,
  },

  "steak-a-la-cava": {
    id: "steak-a-la-cava",
    name: "Steak à la Cava Grecque",
    nameFr: "Steak à la Cava grecque",
    nameKey: "recipes.steakALaCava.name",
    description:
      "Grilled steak with a classic Greek mushroom sauce, served with house rice and Greek potatoes",
    descriptionFr:
      "Steak grillé avec une sauce aux champignons grecque classique, servi avec riz maison et patates grecques",
    descriptionKey: "recipes.steakALaCava.description",
    vegetarian: false,
  },

  "ribeye-steak": {
    id: "ribeye-steak",
    name: "Ribeye Steak",
    nameFr: "Steak d'entrecôte",
    nameKey: "recipes.ribeyeSteak.name",
    description:
      "Juicy ribeye steak, cooked to order and topped with a flavorful mushroom sauce. Served with house rice and Greek potatoes",
    descriptionFr:
      "Steak d'entrecôte juteux, cuit selon vos préférences et nappé d'une savoureuse sauce aux champignons. Servi avec riz maison et patates grecques",
    descriptionKey: "recipes.ribeyeSteak.description",
    vegetarian: false,
  },

  "sirloin-steak": {
    id: "sirloin-steak",
    name: "Sirloin Steak",
    nameFr: "Steak de surlonge",
    nameKey: "recipes.sirloinSteak.name",
    description:
      "Tender sirloin steak finished with a rich mushroom sauce. Accompanied by house rice and Greek potatoes",
    descriptionFr:
      "Steak de surlonge tendre nappé d'une riche sauce aux champignons. Accompagné de riz maison et patates grecques",
    descriptionKey: "recipes.sirloinSteak.description",
    vegetarian: false,
  },

  "pepper-steak": {
    id: "pepper-steak",
    name: "Pepper Steak",
    nameFr: "Steak au poivre",
    nameKey: "recipes.pepperSteak.name",
    description:
      "Ribeye steak coated in cracked black pepper and finished with a creamy pepper sauce. Served with house rice and Greek potatoes",
    descriptionFr:
      "Steak d'entrecôte enrobé de poivre noir concassé et nappé d'une sauce crémeuse au poivre. Servi avec riz maison et patates grecques",
    descriptionKey: "recipes.pepperSteak.description",
    vegetarian: false,
  },

  "lamb-chops": {
    id: "lamb-chops",
    name: "Lamb Chops",
    nameFr: "Côtelettes d'agneau",
    nameKey: "recipes.lambChops.name",
    description:
      "Succulent grilled lamb chops, perfectly seasoned and served with house rice and Greek potatoes",
    descriptionFr:
      "Côtelettes d'agneau grillées et succulentes, parfaitement assaisonnées. Servies avec riz maison et patates grecques",
    descriptionKey: "recipes.lambChops.description",
    vegetarian: false,
  },

  "pork-souvlaki-2": {
    id: "pork-souvlaki-2",
    name: "Pork Souvlaki (2 Skewers)",
    nameFr: "Souvlaki au porc (2 bâtons)",
    nameKey: "recipes.porkSouvlaki2.name",
    description:
      "Tender marinated pork skewers, grilled to perfection and served with fragrant house rice and golden Greek potatoes.",
    descriptionFr:
      "Bâtons de porc marinés tendres, grillés à la perfection et servis avec riz maison parfumé et patates grecques dorées.",
    descriptionKey: "recipes.porkSouvlaki2.description",
    vegetarian: false,
  },

  "chicken-souvlaki-2": {
    id: "chicken-souvlaki-2",
    name: "Chicken Souvlaki (2 Skewers)",
    nameFr: "Souvlaki au poulet (2 bâtons)",
    nameKey: "recipes.chickenSouvlaki2.name",
    description:
      "Juicy marinated chicken skewers, perfectly grilled and served with house rice and Greek potatoes.",
    descriptionFr:
      "Bâtons de poulet marinés juteux, grillés à la perfection et servis avec riz maison et patates grecques.",
    descriptionKey: "recipes.chickenSouvlaki2.description",
    vegetarian: false,
  },

  "chicken-brochette": {
    id: "chicken-brochette",
    name: "Chicken Brochette",
    nameFr: "Brochette de poulet",
    nameKey: "recipes.chickenBrochette.name",
    description:
      "Succulent chicken pieces, skewered and grilled with a savory marinade, accompanied by house rice and Greek potatoes.",
    descriptionFr:
      "Morceaux de poulet succulents, en brochette et grillés avec une marinade savoureuse, accompagnés de riz maison et de patates grecques.",
    descriptionKey: "recipes.chickenBrochette.description",
    vegetarian: false,
  },

  "grilled-chicken-breast": {
    id: "grilled-chicken-breast",
    name: "Grilled Chicken Breast",
    nameFr: "Filet de poulet grillé",
    nameKey: "recipes.grilledChickenBreast.name",
    description:
      "Tender grilled chicken breast, seasoned to perfection, served with house rice and Greek potatoes.",
    descriptionFr:
      "Filet de poulet tendre grillé, assaisonné à la perfection, servi avec riz maison et patates grecques.",
    descriptionKey: "recipes.grilledChickenBreast.description",
    vegetarian: false,
  },

  "pork-brochette": {
    id: "pork-brochette",
    name: "Pork Brochette",
    nameFr: "Brochette de porc",
    nameKey: "recipes.porkBrochette.name",
    description:
      "Flavorful pork chunks skewered and grilled to perfection, served with house rice and Greek potatoes.",
    descriptionFr:
      "Morceaux de porc savoureux en brochette, grillés à la perfection, servis avec riz maison et patates grecques.",
    descriptionKey: "recipes.porkBrochette.description",
    vegetarian: false,
  },

  moussaka: {
    id: "moussaka",
    name: "Moussaka",
    nameFr: "Moussaka",
    nameKey: "recipes.moussaka.name",
    description:
      "Layers of tender eggplant, seasoned ground meat, potatoes, and creamy béchamel, baked to golden perfection.",
    descriptionFr:
      "Couches d'aubergines tendres, viande hachée assaisonnée, patates et béchamel crémeuse, cuites au four jusqu'à dorure parfaite.",
    descriptionKey: "recipes.moussaka.description",
    vegetarian: false,
  },

  "chef-salad": {
    id: "chef-salad",
    name: "Chef Salad",
    nameFr: "Salade du chef",
    nameKey: "recipes.chefSalad.name",
    description:
      "A crisp blend of fresh greens, tomatoes, cucumbers, and assorted toppings for a classic chef-style salad.",
    descriptionFr:
      "Mélange croquant de légumes verts frais, tomates, concombres et garnitures assorties pour une salade classique du chef.",
    descriptionKey: "recipes.chefSalad.description",
    vegetarian: true,
  },

  "chef-salad-chicken": {
    id: "chef-salad-chicken",
    name: "Chef Salad with Grilled Chicken",
    nameFr: "Salade du chef avec poulet grillé",
    nameKey: "recipes.chefSaladChicken.name",
    description:
      "A crisp blend of fresh greens, tomatoes, cucumbers, and assorted toppings, topped with tender grilled chicken.",
    descriptionFr:
      "Mélange croquant de légumes verts frais, tomates, concombres et garnitures assorties, garni de poulet grillé tendre.",
    descriptionKey: "recipes.chefSaladChicken.description",
    vegetarian: false,
  },

  "chef-salad-salmon": {
    id: "chef-salad-salmon",
    name: "Chef Salad with Grilled Salmon",
    nameFr: "Salade du chef avec saumon grillé",
    nameKey: "recipes.chefSaladSalmon.name",
    description:
      "Fresh greens with tomatoes, cucumbers, and assorted toppings, crowned with flavorful grilled salmon.",
    descriptionFr:
      "Légumes verts frais avec tomates, concombres et garnitures assorties, surmontés de saumon grillé savoureux.",
    descriptionKey: "recipes.chefSaladSalmon.description",
    vegetarian: false,
  },

  "caesar-salad": {
    id: "caesar-salad",
    name: "Caesar Salad",
    nameFr: "Salade César",
    nameKey: "recipes.caesarSalad.name",
    description:
      "Crisp romaine lettuce tossed with Parmesan cheese, crunchy croutons, and Caesar dressing.",
    descriptionFr:
      "Laitue romaine croquante mélangée avec du parmesan, des croûtons croustillants et une sauce César.",
    descriptionKey: "recipes.caesarSalad.description",
    vegetarian: true,
  },

  "caesar-salad-chicken": {
    id: "caesar-salad-chicken",
    name: "Caesar Salad with Grilled Chicken",
    nameFr: "Salade César avec poulet grillé",
    nameKey: "recipes.caesarSaladChicken.name",
    description:
      "Crisp romaine lettuce with Parmesan cheese, croutons, Caesar dressing, and tender grilled chicken.",
    descriptionFr:
      "Laitue romaine croquante avec parmesan, croûtons, sauce César et poulet grillé tendre.",
    descriptionKey: "recipes.caesarSaladChicken.description",
    vegetarian: false,
  },

  "greek-salad": {
    id: "greek-salad",
    name: "Greek Salad",
    nameFr: "Salade grecque",
    nameKey: "recipes.greekSalad.name",
    description:
      "A refreshing mix of crisp greens, tomatoes, cucumbers, olives, and feta cheese with a light vinaigrette.",
    descriptionFr:
      "Mélange rafraîchissant de légumes verts croquants, tomates, concombres, olives et fromage feta avec une vinaigrette légère.",
    descriptionKey: "recipes.greekSalad.description",
    vegetarian: true,
  },

  "greek-salad-chicken": {
    id: "greek-salad-chicken",
    name: "Greek Salad with Grilled Chicken",
    nameFr: "Salade grecque avec poulet grillé",
    nameKey: "recipes.greekSaladChicken.name",
    description:
      "Crisp greens, tomatoes, cucumbers, olives, and feta, topped with succulent grilled chicken.",
    descriptionFr:
      "Légumes verts croquants, tomates, concombres, olives et feta, surmontés de poulet grillé succulent.",
    descriptionKey: "recipes.greekSaladChicken.description",
    vegetarian: false,
  },

  "vegetarian-plate": {
    id: "vegetarian-plate",
    name: "Vegetarian Plate",
    nameFr: "Assiette végétarienne",
    nameKey: "recipes.vegetarianPlate.name",
    description:
      "A hearty plate of seasonal vegetables, grains, and fresh greens, perfect for a satisfying vegetarian meal.",
    descriptionFr:
      "Assiette copieuse de légumes de saison, céréales et légumes verts frais, parfaite pour un repas végétarien satisfaisant.",
    descriptionKey: "recipes.vegetarianPlate.description",
    vegetarian: true,
  },

  "gyro-1": {
    id: "gyro-1",
    name: "Gyro (1 Skewer)",
    nameFr: "Gyro (1 Brochette)",
    nameKey: "recipes.gyro1.name",
    description:
      "Classic Greek-style gyro with seasoned meat, grilled and served with fresh pita bread.",
    descriptionFr:
      "Gyro classique à la grecque avec viande assaisonnée, grillée et servie avec du pain pita frais.",
    descriptionKey: "recipes.gyro1.description",
    vegetarian: false,
  },

  "gyro-2": {
    id: "gyro-2",
    name: "Gyro (2 Skewers)",
    nameFr: "Gyro (2 Brochettes)",
    nameKey: "recipes.gyro2.name",
    description:
      "Two skewers of seasoned gyro meat, grilled and served with fresh pita bread for a hearty meal.",
    descriptionFr:
      "Deux brochettes de viande de gyro assaisonnée, grillées et servies avec du pain pita frais pour un repas copieux.",
    descriptionKey: "recipes.gyro2.description",
    vegetarian: false,
  },

  "hamburger-steak": {
    id: "hamburger-steak",
    name: "Hamburger Steak",
    nameFr: "Hamburger Steak",
    nameKey: "recipes.hamburgerSteak.name",
    description:
      "Juicy hamburger steak topped with rich mushroom sauce. Served with rice and Greek-style roasted potatoes.",
    descriptionFr:
      "Steak haché juteux nappé de sauce aux champignons. Servi avec riz et pommes de terre rôties à la grecque.",
    descriptionKey: "recipes.hamburgerSteak.description",
    vegetarian: false,
  },

  "grilled-chicken-butterfly-shrimp": {
    id: "grilled-chicken-butterfly-shrimp",
    name: "Grilled Chicken Breast and 2 Butterfly Shrimp",
    nameFr: "Filet de poulet grillé et 2 crevettes papillon",
    nameKey: "recipes.chickenBreastShrimp.name",
    description:
      "Grilled chicken breast served with two golden fried butterfly shrimp, rice, and Greek-style roasted potatoes.",
    descriptionFr:
      "Filet de poulet grillé servi avec deux crevettes papillon dorées, riz et pommes de terre rôties à la grecque.",
    descriptionKey: "recipes.chickenBreastShrimp.description",
    vegetarian: false,
  },

  "pork-shish-kebab": {
    id: "pork-shish-kebab",
    name: "Pork Brochette (Shish Kebab)",
    nameFr: "Brochette de Porc (Shish Kebab)",
    nameKey: "recipes.porkShishKebab.name",
    description:
      "Tender pork brochette marinated in Greek spices and grilled. Served with rice and Greek-style roasted potatoes.",
    descriptionFr:
      "Brochette de porc tendre marinée aux épices grecques et grillée. Servie avec riz et pommes de terre rôties à la grecque.",
    descriptionKey: "recipes.porkShishKebab.description",
    vegetarian: false,
  },

  "steak-cava": {
    id: "steak-cava",
    name: "La Cava Grecque Steak",
    nameFr: "Steak à la Cava Grecque",
    nameKey: "recipes.steakCava.name",
    description:
      "Juicy steak topped with a savory mushroom sauce. Served with rice and Greek-style roasted potatoes.",
    descriptionFr:
      "Steak juteux garni d'une savoureuse sauce aux champignons. Servi avec riz et pommes de terre rôties à la grecque.",
    descriptionKey: "recipes.steakCava.description",
    vegetarian: false,
  },
};
